(function ($, Drupal, once) {
  'use strict';
  Drupal.behaviors.weaver_tailwind_onthispage = {

    onThisPageLinksCollapse: function() {
      const otpBlocks = document.querySelectorAll('.paragraph--type--ptb-on-page .ptb-on-page-toggle');

      if (otpBlocks <= 0) {
        return;
      }

      if (window.screen.width > 1388) {
        return;
      }

      otpBlocks.forEach((otpBlock) => {
      
        let otpLinks = otpBlock.querySelectorAll('.field--name-field-ptb-links a');

        otpLinks.forEach(otpLink => {

          otpLink.addEventListener('click', (e) => {
            let collapseLink = otpBlock.querySelector('[data-twe-collapse-init]');
            collapseLink.click();
          });

        });
      });
    },

    onThisPageObserverCallback: function(entries, observer, element) {
      const stickyScrolledClasses = ['max-xl:fixed', 'max-xl:bottom-0', 'max-xl:left-0'];

      entries.forEach((entry) => {

        if (entry.isIntersecting) {
          stickyScrolledClasses.forEach((stickyClass) => {
            entry.target.classList.add(stickyClass);
          });
        }
      });
    },

    onThisPageObserverInitialize: function() {
      const otpBlocks = document.querySelectorAll('.paragraph--type--ptb-on-page .ptb-on-page-toggle');
      if (otpBlocks <= 0) {
        return;
      }

      if (window.screen.width < 1388) {
        otpBlocks.forEach((otpBlock) => {
          var observer = new IntersectionObserver(entries => {
            this.onThisPageObserverCallback(entries, observer, otpBlock);
          }, 
          { threshold: 0.5 });
          observer.observe(otpBlock);
        });
      }
    },

    attach: function (context, settings) {

      $(once('weaver_tailwind_onthispage', 'body', context)).each(function () {
        const weaver_onthispage = Drupal.behaviors.weaver_tailwind_onthispage;

        weaver_onthispage.onThisPageLinksCollapse();

        window.addEventListener('resize', () => {
          weaver_onthispage.onThisPageLinksCollapse();
        });
      });
    }
  };
})(jQuery, Drupal, once);